import { colorsNew } from 'components/common/charts/helpers/config';

export const createConfig = (
  ticketsCharts,
  notAreaArr,
  loaderChart,
  chartColor
) => {
  //   get all area keys
  const keys =
    !loaderChart && ticketsCharts[0] ? Object.keys(ticketsCharts[0]) : [];
  for (let i = 0; i < notAreaArr.length; i += 1) {
    const index = keys.indexOf(notAreaArr[i]);
    if (index !== -1) {
      keys.splice(index, 1);
    }
  }
  keys.push(notAreaArr[1]);

  //create configuration for chart
  return keys.map((item, index) => {
    if (item !== notAreaArr[1]) {
      return {
        name: item,
        value: true,
        color: chartColor
          ? chartColor[item]
            ? chartColor[item]
            : colorsNew[index]
          : colorsNew[index],
        type: 'area'
      };
    } else {
      return {
        name: item,
        value: true,
        color: 'transparent',
        type: 'area',
        invisible: true
      };
    }
  });
};
